<template>
    <div>
        <v-container>
            <div>
                <v-row>
                    <v-col>
                        <h2 style="padding-left:2px;">Login</h2>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col v-if="spinner == true" align="center">
                        <v-progress-circular :color="($vuetify.theme.dark) ? 'var(--darkColor)' : 'var(--lightColor)'" size="120" indeterminate></v-progress-circular>
                    </v-col>
                    <v-col v-if="spinner == false">
                        <v-card>
                            <v-form ref="loginForm" class="mx-2" lazy-validation>
                                <v-card-text>
                                    <v-text-field v-model="email" v-on:keyup.enter="onEnter" label="Email"
                                        :rules="emailRules" required>
                                    </v-text-field>
                                    <v-text-field type="password" v-model="password" v-on:keyup.enter="onEnter"
                                        :rules="[v => !!v || 'Password is required']" label="Password" required>
                                    </v-text-field>
                                </v-card-text>

                                <v-card-actions>
                                    <a class="float-left" :class="($vuetify.theme.dark) ? 'darkPrime' : 'lightPrime'" style="padding-left:8px;"
                                        v-on:click="goToForgottenPassword">Forgotten password?</a>
                                    <v-spacer></v-spacer>
                                    <v-btn v-on:click="validateForm" class="float-right" :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'">Submit</v-btn>
                                </v-card-actions>
                            </v-form>
                        </v-card>
                    </v-col>
                </v-row>
            </div>
        </v-container>
    </div>
</template>

<script>
import RestResource from '../RestResource.js';
import { mapActions, mapGetters } from 'vuex';
const restResourceService = new RestResource();
export default {
    name: "LoginPage",
    setup() {

    },
    props: {

    },
    components: {

    },
    data: () => ({
        spinner: false,
        email: "",
        password: "",

        emailRules: [],
    }),
    mounted() {
        if (this.getAccount != null)
            this.$router.push({ path: "/" });
    },
    computed:
        mapGetters([
            'getAccount',
        ]),

    watch: {
        email() {
            this.emailRules = [];
        }
    },
    methods: {
        ...mapActions([
            'fetchAccount',
            'fetchAccountBalance',
            'loginToApp'
        ]),
        onEnter: function () {
            this.submitForm();
        },
        validateForm() {
            //Add Rules to form
            this.emailRules = [v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Email must be valid'];

            //Wait for rules to complete then check if they have been broken. 
            let self = this;
            setTimeout(function () {
                if (self.$refs.loginForm.validate())
                    self.submitForm();
                else
                    return self.$emit('snack', 'Invalid Inputs');
            })
        },
        async submitForm() {
            this.spinner = true;
            let email = this.email.replaceAll(" ", "");
            //Submit form 
            const isLogged = await restResourceService.postLogin(email, this.password);
            //Complete for then or catch
            this.spinner = false;
            this.email = "";
            this.password = "";
            //Do for Catch
            if (!isLogged) 
                return;
            //Do on then 
            this.loginToApp();
            await this.fetchAccount();
            this.fetchAccountBalance();
           
            this.spinner = false;
            this.$router.push({ path: '/' });


        },
        setAccountId: function (accountId) {
            this.$emit('accountId', accountId);
        },
        goToForgottenPassword: function () {
            this.$router.push({ path: "/forgottenpassword" });
        },
        goToInstall: function () {
            this.$router.push({ path: "/InstallPage" })
        }
    },
}
</script>

<style scoped>
</style>